import { memo, useCallback, useMemo } from "react";

import type { RegistrationStatusType } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";
import { Label } from "@/components/ui/label/label";

import * as Constants from "./constants";

type Props = {
	registrationStatus: ForNodeType<RegistrationStatusType>;
	registrationCode?: ForNodeType<string | null | undefined>;

	onChangeRegistrationStatus: (value: RegistrationStatusType) => void;
	onChangeRegistrationCode: (value: number | undefined) => void;
};

export const RegistrationForm = memo(
	({
		registrationStatus,
		registrationCode,

		onChangeRegistrationStatus,
		onChangeRegistrationCode,
	}: Props) => {
		const handleChangeRegistrationStatus = useCallback(
			(value: string) => onChangeRegistrationStatus(value as RegistrationStatusType),
			[onChangeRegistrationStatus],
		);

		const handleChangeRegistrationCode = useCallback(
			(value: number | undefined) => onChangeRegistrationCode(value),
			[onChangeRegistrationCode],
		);

		const registrationStatusValue = useMemo(() => registrationStatus.value, [registrationStatus.value]);
		const registrationCodeValue = useMemo(
			() => (registrationCode?.value ? Number(registrationCode.value) : undefined),
			[registrationCode?.value],
		);
		const registrationCodeError = useMemo(() => registrationCode?.error, [registrationCode?.error]);

		return (
			<div>
				<div className="flex w-full flex-col gap-y-4 p-5 laptop:flex-row laptop:items-center laptop:gap-x-6 laptop:gap-y-0">
					<div className="grid w-full laptop:max-w-72 laptop:flex-none">
						<div className="flex items-center gap-x-2 laptop:mt-2">
							<h5>現在の登録状況</h5>
							<Label text="必須" size="sm" />
						</div>
					</div>
					<div className="flex-1">
						<div>
							<RadioGroupField
								value={registrationStatusValue}
								options={Constants.OptionsForRegistrationStatus}
								handleValueChange={handleChangeRegistrationStatus}
							/>
						</div>
					</div>
				</div>

				<div className="mt-1 border-b border-zinc-300" />

				<div className="flex w-full flex-col gap-y-4 px-5 pt-5 laptop:flex-row laptop:items-center laptop:gap-x-6 laptop:gap-y-0">
					<div className="grid w-full laptop:max-w-72 laptop:flex-none">
						<h5>登録番号（T を除く13桁の半角数字）</h5>
					</div>
					<div className="flex-1">
						<div className="flex items-center gap-x-3">
							<p className="text-2xl font-bold">T</p>
							<InputNumberField
								value={registrationCodeValue}
								hiddenSpinButton
								handleInput={handleChangeRegistrationCode}
								errorMessage={registrationCodeError}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	},
);
